import css from 'styled-jsx/css';

const styles = css.global`.custom-carousel.fill-height, .custom-carousel .fill-height {
    width: 100%;
}
.custom-tabs.tabs-container .tab-item {
    flex: 0 0 50% !important;
}

.custom-tabs.tabs-container {
    padding: 32px 15px;
}

@media (min-width: 576px) {
    .custom-tabs.tabs-container .tab-item {
        flex: 0 0 145px !important;
    }
}`;

export default styles;